import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import classnames from "classnames";
import React from "react";

export const Step = ({ isLast, label, info }) => {
  return (
    <div className="tw-flex">
      <div className="tw-mr-2 tw-flex tw-items-center tw-flex-col">
        <CheckCircleRoundedIcon className="!tw-text-[#d5d2f0]" />
        {!isLast && (
          <div className="tw-flex-1 tw-border-l-2 tw-border-dashed tw-border-0 tw-border-[#e7e6e4]" />
        )}
      </div>

      <div
        className={classnames(
          "tw-ml-1 tw-pb-2",
          isLast ? "tw-mb-2" : "tw-mb-4"
        )}
      >
        <div className="tw-text-[#2c207e] tw-text-sm tw-font-medium tw-leading-normal tw-tracking-[0.28px] tw-mb-[9px]">
          {label}
        </div>
        <div className="tw-text-[rgba(39,37,34,0.5)] tw-text-xs tw-font-normal tw-leading-[17px] tw-tracking-[0.24px]">
          {info}
        </div>
      </div>
    </div>
  );
};
